export default "__VITE_ASSET__CvKzfPbL__"